import { defaultPaginatedResponse, mapPaginatedResponse } from '@/mappers/common.mapper';
import { mapPhoneNumberResponse } from '@/mappers/phone-number.mapper';

import type {
  AssignAgentFormValues,
  PhoneNumberCreateFormValues,
} from '@/schemas/phone-number.schema';

import apiClient from '@/lib/api-client';
import { raiseAxiosErrorOrDefault } from '@/lib/error';
import { buildQueryParams } from '@/lib/utils';

import type { PaginatedResponse } from '@/types/common.type';
import type { PhoneNumberConfiguration, PhoneNumberFilterParams } from '@/types/phone-number.type';

export const createPhoneNumber = async (payload: PhoneNumberCreateFormValues) => {
  try {
    await apiClient.post('/phone-numbers', payload);
  } catch (error) {
    raiseAxiosErrorOrDefault(error, 'Failed to create phone number');
  }
};

export const fetchAllPhoneNumbers = async (
  params?: PhoneNumberFilterParams
): Promise<PaginatedResponse<PhoneNumberConfiguration>> => {
  try {
    const response = await apiClient.get<PaginatedResponse<PhoneNumberConfiguration>>(
      '/phone-numbers',
      mapPaginatedResponse(mapPhoneNumberResponse),
      {
        params: buildQueryParams(params, {
          is_associated: params?.is_associated,
        }),
      }
    );
    return response;
  } catch {
    return defaultPaginatedResponse<PhoneNumberConfiguration>();
  }
};

export const assignPhoneNumber = async (
  phoneNumberId: number,
  payload: AssignAgentFormValues
): Promise<void> => {
  try {
    await apiClient.patch(`/phone-number/${phoneNumberId}/assign-agent`, payload);
  } catch (error) {
    raiseAxiosErrorOrDefault(error, 'Failed to assign phone number');
  }
};

export const deletePhoneNumberById = async (phoneNumberId: number): Promise<void> => {
  try {
    await apiClient.delete(`/phone-number/${phoneNumberId}`);
  } catch (error) {
    raiseAxiosErrorOrDefault(error, 'Failed to delete phone number');
  }
};
